module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "main-container",
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [(_vm.imgs.length) ? _c('SlideShow', {
    attrs: {
      "imgs": _vm.imgs
    },
    on: {
      "imgClick": _vm.bannerImgClicked
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "clearfix tag-list",
    class: {
      "fixed": _vm.tagListFixed
    },
    style: ({
      'padding-left': (_vm.tagListFixed && _vm.offsetLeft ? _vm.offsetLeft : 0) + 'px'
    })
  }, _vm._l((_vm.tags), function(tag) {
    return _c('li', {
      key: tag.id,
      class: {
        'active': tag.id === _vm.activeTagId
      },
      on: {
        "click": function($event) {
          _vm.changeTag(tag)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag.typeName) + "\n        ")])
  })), _vm._v(" "), (_vm.activeTagId !== -2) ? _c('ul', {
    staticClass: "clearfix announcement-list"
  }, _vm._l((_vm.announcements), function(announcement) {
    return _c('Announcement', {
      key: announcement.id,
      attrs: {
        "item": announcement
      },
      on: {
        "itemClicked": _vm.announceClicked
      }
    })
  })) : _vm._e(), _vm._v(" "), _vm._l((_vm.goodCourses), function(courses) {
    return (_vm.activeTagId === -2 && courses.announcePublishVOList && courses.announcePublishVOList.length) ? _c('section', {
      key: courses.id
    }, [(courses.tagName) ? _c('h3', {
      staticClass: "section-class"
    }, [_c('hr'), _vm._v(" "), _c('span', [_vm._v(_vm._s(courses.tagName))]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "clearfix announcement-list"
    }, _vm._l((courses.announcePublishVOList), function(announcement, index) {
      return (index <= 3) ? _c('Announcement', {
        key: announcement.id,
        attrs: {
          "item": announcement
        },
        on: {
          "itemClicked": _vm.announceClicked
        }
      }) : _vm._e()
    }))]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75887188","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/academy/HomePage.vue
// module id = 785
// module chunks = 0